"use client"

import { GetPageByRouteQuery } from "apollo"
import { ArticlesData, getBreadCrumbs } from "utils"
import PageHeader from "../Common/PageHeader"
import ArticleTabs from "./ArticleTabs"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  articlesData: ArticlesData[]
}

export default function PeopleOfEgged({ data, locale, articlesData }: Props) {
  const breadCrumbs = getBreadCrumbs(data, locale)
  const pageTitle = breadCrumbs.selfObject.title
  return (
    <>
      <PageHeader breadCrumbs={breadCrumbs} title={pageTitle} />
      <ArticleTabs articlesData={articlesData} />
    </>
  )
}
